<template>
    <div class="shopMobStarSubject">
        <div class="titleBox" v-if="setting.isdisplaytitle">{{setting.titlename}}</div>
        <div class="listBox" v-for="(item, index) in setting.datalist" :key="index">
            <div class="topMsg">
                <div class="left">
                    <div class="imgBox">
                        <img :src="item.furl" alt="">
                    </div>
                    <p class="name">{{item.starname}}</p>
                </div>
                <div class="right">{{item.datetime}}</div>
            </div>
            <!--1张图-->
            <div class="list1" v-if="item.contenttype==1 && item.attList.length <= 2">
                <div class="left">
                    <p class="title" v-if="item.objectname">{{item.objectname}}</p>
                    <div class="viewComment">
                        <span class="type" v-if="item.tagname">#{{item.tagname}}#</span>
                        <div class="viewCount">
                            <img :src="require('@/common/images/shop/icon_eye@2x.png')" alt="">
                            <span>{{item.viewcount}}</span>
                        </div>
                        <div class="commentCount">
                            <img :src="require('@/common/images/shop/comment.png')" alt="">
                            <span>{{item.commentcount}}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <img :src="obj.attUrl" alt="" v-for="(obj,index) in item.attList.slice(0, 1)" :key="index">
                </div>
            </div>
            <!--无图-->
            <div class="list2" v-if="item.contenttype==1 && item.attList.length ==0">
                <p class="title" v-if="item.objectname">{{item.objectname}}</p>
                <div class="viewComment">
                    <div class="viewCount">
                        <img :src="require('@/common/images/shop/icon_eye@2x.png')" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                    <div class="commentCount">
                        <img :src="require('@/common/images/shop/comment.png')" alt="">
                        <span>{{item.commentcount}}</span>
                    </div>
                </div>
            </div>
            <!--视频-->
            <div class="list3" v-if="item.contenttype==3">
                <p class="title" v-if="item.objectname">{{item.objectname}}</p>
                <div class="videoBox">
                    <video :src="obj.attUrl" alt="" v-for="(obj,index) in item.attList" :key="index" class="video"></video>
                </div>
                <div class="viewComment">
                    <span class="type" v-if="item.tagname">#{{item.tagname}}#</span>
                    <div class="viewCount">
                        <img :src="require('@/common/images/shop/icon_eye@2x.png')" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                    <div class="commentCount">
                        <img :src="require('@/common/images/shop/comment.png')" alt="">
                        <span>{{item.commentcount}}</span>
                    </div>
                </div>
            </div>
            <!--3张图-->
            <div class="list4" v-if="item.contenttype==1 && item.attList.length >=3">
                <p class="title" v-if="item.objectname">{{item.objectname}}</p>
                <div class="imgBox">
                    <div class="img1">
                        <img :src="obj.attUrl" alt="" v-for="(obj,index) in item.attList.slice(0, 3)" :key="index">
                    </div>
                    <div class="img2">
                        <img src="" alt="">
                    </div>
                    <div class="img3">
                        <img src="" alt="">
                    </div>
                </div>
                <div class="viewComment">
                    <span class="type" v-if="item.tagname">#{{item.tagname}}#</span>
                    <div class="viewCount">
                        <img :src="require('@/common/images/shop/icon_eye@2x.png')" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                    <div class="commentCount">
                        <img :src="require('@/common/images/shop/comment.png')" alt="">
                        <span>{{item.commentcount}}</span>
                    </div>
                </div>
            </div>
            <!--附件-->
            <div class="list5" v-if="item.contenttype==2">
                <p class="title" v-if="item.objectname">{{item.objectname}}</p>
                <div class="enclosures">
                    <div v-for="(obj,index) in item.attList" :key="index" class="enclosure icon_shop_copy">{{obj.attname}}</div>
                </div>
                <div class="viewComment">
                    <span class="type" v-if="item.tagname">#{{item.tagname}}#</span>
                    <div class="viewCount">
                        <img :src="require('@/common/images/shop/icon_eye@2x.png')" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                    <div class="commentCount">
                        <img :src="require('@/common/images/shop/comment.png')" alt="">
                        <span>{{item.commentcount}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import {getStarSbjectList} from 'api/shop'
export default {
    name: 'shopMobStarSubject',
    data() {
        return {
            data: {
                // contenttype: 1图文 3视频 2附件
                title: '精选话题',
                list: [
                    {name: '快乐的星球', time: '08-20  22:12', img: require('@/common/images/shop/banner.png'), title: '产品经理入坑指南(三):两则示例透视产品经理核心技能', viewcount: '123', commentcount: '123', type: '#产品#'}
                ]
            }
        }
    },
    props: ['setting'],
    mounted() {
        this._getStarTopicPageList()
    },
    methods: {
        _getStarTopicPageList() {
            this.setLoading(true)
            getStarSbjectList({
                data: {
                    datasource: 1,
                    datacount: 10
                },
                success: data => {
                    let tmp = data.data.content
                    let tmpList = $.extend(true, [], this.shopMob)
                    tmpList.forEach((obj,index) => {
                        if (obj.comtype === 'starsubject') {
                            obj.datalist = tmp
                        }
                    })
                    this.setShopMob(tmpList)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setShopMob',
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    }
}
</script>
<style lang="scss">
@import "~common/scss/base";
@import "~common/scss/mixin";
    .shopMobStarSubject{
        width: 100%;
        padding: 0.64rem;
        padding-bottom: 0;
        background: #fff;
        box-sizing: border-box;
        // min-height: 227px;
        .titleBox{
            font-size: 0.68rem;
            font-weight: 600;
            line-height: 0.84rem;
            width: 13.5rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .listBox{
            padding-top: 0.32rem;
            .topMsg{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.68rem;
                .left{
                    display: flex;
                    align-items: center;
                    flex: 1;
                    margin-right: 1rem;
                    .imgBox{
                        width: 1rem;
                        height: 1rem;
                        img{
                            width: 1rem;
                            height: 1rem;
                            border-radius: 50%;
                        }
                    }
                    .name{
                        color: #409EFF;
                        margin-left: 0.32rem;
                        font-size: 0.48rem;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        flex: 1;
                        width: 8rem;
                    }
                }
                .right{
                    color: #909399;
                    font-size: 0.48rem;
                }
            }
            .list1{
                display: flex;
                padding-bottom: 0.64rem;
                border-bottom: 0.02rem solid #DCDFE6;
                .left{
                    .title{
                        width: 8.6rem;
                        height: 2.04rem;
                        font-size: 0.64rem;
                        line-height: 1rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-weight: 500;
                    }
                    .viewComment{
                        padding-top: 0.36rem;
                        display: flex;
                        .type{
                            color: #409EFF;
                            margin-right: 0.48rem;
                        }
                        &>div{
                            display: flex;
                            align-items: center;
                            margin-right: 0.48rem;
                            img{
                                width: 0.48rem;
                                height: 0.48rem;
                                margin-right: 0.24rem;
                            }
                            span{
                                font-size: 0.48rem;
                                color: #909399;
                                margin-left: 0.04rem;
                            }
                        }
                    }
                }
                .right{
                    img{
                        width: 4.5rem;
                        height: 3rem;
                        border-radius: 0.08rem;
                    }
                }
            }
            .list2, .list3, .list4, .list5{
                border-bottom: 0.02rem solid #DCDFE6;
                .title{
                    width: 100%;
                    height: 2.04rem;
                    font-size: 0.64rem;
                    line-height: 1rem;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    font-weight: 500;
                }
                .imgBox{
                    display: flex;
                    height: 3rem;
                    img{
                        width: 4.5rem;
                        height: 3rem;
                        border-radius: 0.08rem;
                    }
                }
                .bigImgBox{
                    width: 100%;
                    height: 7.72rem;
                    img{
                        width: 100%;
                        height: 7.72rem;
                        margin-right: 0.24rem;
                    }
                }
                .viewComment{
                    margin-top: 0.48rem;
                    display: flex;
                    align-items: center;
                    .type{
                        color: #409EFF;
                        margin-right: 0.48rem;
                    }
                    &>div{
                        margin-right: 0.48rem;
                        display: flex;
                        align-items: center;
                        img{
                            width: 0.48rem;
                            height: 0.48rem;
                            margin-right: 0.24rem;
                        }
                        span{
                            color: #909399;
                            font-size: 0.48rem;
                            margin-left: 0.04rem;
                        }
                    }
                }
                .videoBox{
                    width: 100%;
                    height: 7.72rem;
                    margin-top: 0.32rem;
                    margin-bottom: 0.5rem;
                    text-align: center;
                    video{
                        height: 100%;
                        width: 100%;
                    }
                }
                .enclosures{
                    .enclosure{
                        color: #409EFF;
                        margin-bottom: 0.2rem;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        &:before{
                            width: 0.48rem;
                            height: 0.416rem;
                            margin-right: 0.16rem;
                        }
                    }
                }
            }
            .list3, .list4, .list5{
                .viewComment{
                    padding-bottom: 0.64rem;
                }
            }
        }
    }
</style>
